module.exports = __webpack_public_path__ + "static/media/icon_round-cancel-24px.c55ad80d.svg";